var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgStar(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 46,
    viewBox: "0 0 48 46",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M21.5085 2.32309L15.8401 13.8161L3.15781 15.6651C0.883505 15.995 -0.0279536 18.7988 1.62135 20.4047L10.7967 29.3457L8.62656 41.9759C8.23594 44.2589 10.6404 45.9689 12.6543 44.9012L23.9998 38.9377L35.3453 44.9012C37.3592 45.9602 39.7637 44.2589 39.3731 41.9759L37.2029 29.3457L46.3783 20.4047C48.0276 18.7988 47.1161 15.995 44.8418 15.6651L32.1595 13.8161L26.4911 2.32309C25.4755 0.274484 22.5328 0.248442 21.5085 2.32309Z",
    fill: "#C9A730"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStar);
export default __webpack_public_path__ + "static/media/star.937e3ae3dd0a67cd6210dda7640e86ba.svg";
export { ForwardRef as ReactComponent };